import { useEffect, useState } from "react";
import { safeGetItem, safeSetItem } from "@/lib/safeStorage";

/**
 * Animated arrow that points to the hamburger menu
 * Shows only for first-time users to guide them to the menu
 */
export default function MenuArrowGuide() {
  const [showArrow, setShowArrow] = useState(false);

  useEffect(() => {
    // Check if user has seen the menu guide
    const hasSeenMenuGuide = safeGetItem("menu_guide_shown");

    if (!hasSeenMenuGuide) {
      // Show arrow after a short delay (2 seconds)
      const timer = setTimeout(() => {
        setShowArrow(true);
      }, 2000);

      // Auto-hide after 10 seconds
      const hideTimer = setTimeout(() => {
        setShowArrow(false);
        safeSetItem("menu_guide_shown", "true");
      }, 12000);

      return () => {
        clearTimeout(timer);
        clearTimeout(hideTimer);
      };
    }
  }, []);

  const handleDismiss = () => {
    setShowArrow(false);
    safeSetItem("menu_guide_shown", "true");
  };

  if (!showArrow) return null;

  return (
    <div
      className="fixed top-20 right-6 z-[60] pointer-events-none md:hidden"
      onClick={handleDismiss}
    >
      {/* Text bubble */}
      <div className="relative mb-2 pointer-events-auto">
        <div className="bg-primary text-primary-foreground px-4 py-2 rounded-lg shadow-lg animate-pulse">
          <p className="text-sm font-semibold whitespace-nowrap">
            Tap here for menu! 👆
          </p>
        </div>
        {/* Triangle pointer */}
        <div className="absolute -bottom-2 right-4 w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-8 border-t-primary"></div>
      </div>

      {/* Animated arrow pointing up-right */}
      <div className="flex justify-end animate-bounce">
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="text-primary drop-shadow-lg"
          style={{ transform: "rotate(-45deg)" }}
        >
          <path
            d="M7 17L17 7M17 7H7M17 7V17"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
}
